module.exports = __webpack_public_path__ + "angel.ddbbba61.png";